import { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cc from 'classcat';
import noScroll from 'no-scroll';

import { getEnvironment } from '../../lib/utils';
import { themes } from '../../lib/themes';
import Link from '../Link';
import { To, BREAKPOINTS } from '../Responsive';

import styles from './styles.module.scss';

const { DIETBET_GAME_SERVICE_HOST } = getEnvironment();

class ProfileMenu extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    product: PropTypes.oneOf(themes),
    onClose: PropTypes.func,
  };
  static defaultProps = {
    product: 'waybetter',
    onClose: () => {},
  };
  static displayName = 'ProfileMenu';

  state = {
    viewportWidth: 0,
  };

  constructor(props) {
    super(props);

    this.state.viewportWidth = window.innerWidth;
  }

  updateHeight = () => {
    const viewportWidth = window.innerWidth;
    this.setState({ viewportWidth });

    if (window.innerWidth <= BREAKPOINTS[1]) {
      noScroll.on();
    } else {
      noScroll.off();
    }
  };

  handleClose = () => this.props.onClose();

  preventBubble(event) {
    event.stopPropagation();
  }

  componentDidMount() {
    this.updateHeight();
    window.addEventListener('resize', this.updateHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
    noScroll.off();
  }

  render() {
    const { product, name, className } = this.props;
    const { handleClose } = this.state;
    const menu = (
      <ul
        onMouseLeave={handleClose}
        onClick={handleClose}
        className={cc([styles.container, className])}
      >
        <li className={styles.nameItem} onClick={this.preventBubble}>
          <span className={styles.name}>{name}</span>
        </li>
        {['dietbet'].includes(product) && (
          <li>
            <Link
              theme="none"
              to={`${DIETBET_GAME_SERVICE_HOST}/user/games?utm_source=hub&utm_medium=link&utm_campaign=db_top_nav`}
              className={styles.link}
              onClick={handleClose}
            >
              My games
            </Link>
          </li>
        )}

        {['dietbet', 'stepbet'].includes(product) && (
          <li>
            <Link
              theme="none"
              to={`/profile/${product}/membership`}
              className={styles.link}
              onClick={handleClose}
            >
              Membership
            </Link>
          </li>
        )}
        {product === 'dietbet' && (
          <Fragment>
            <li>
              <Link
                theme="none"
                to={`${DIETBET_GAME_SERVICE_HOST}/invite`}
                className={styles.link}
                onClick={handleClose}
              >
                Invite
              </Link>
            </li>
            <li>
              <Link
                theme="none"
                to={`${DIETBET_GAME_SERVICE_HOST}/user/profile`}
                className={styles.link}
                onClick={handleClose}
              >
                User profile
              </Link>
            </li>
            <li>
              <Link
                theme="none"
                to={`${DIETBET_GAME_SERVICE_HOST}/user/account`}
                className={styles.link}
                onClick={handleClose}
              >
                Settings
              </Link>
            </li>
            <li>
              <Link
                theme="none"
                to={`${DIETBET_GAME_SERVICE_HOST}/user/points#points`}
                className={styles.link}
                onClick={handleClose}
              >
                Points
              </Link>
            </li>
          </Fragment>
        )}
        <li>
          <Link
            theme="none"
            to={`/logout?product=${product}`}
            className={styles.link}
            onClick={handleClose}
          >
            Log out
          </Link>
        </li>
      </ul>
    );

    return (
      <To slice={1}>
        {(matches) =>
          matches ? ReactDOM.createPortal(menu, document.body) : menu
        }
      </To>
    );
  }
}

export default ProfileMenu;
